import { GetAllLicensesInDto, GetAllLicensesOutDto } from '../../../types/license.dto'

export const GET_ALL_LICENSES = 'GET_ALL_LICENSES'
export const GET_ALL_LICENSES_SUCCESS = 'GET_ALL_LICENSES_SUCCESS'
export const GET_ALL_LICENSES_ERROR = 'GET_ALL_LICENSES_ERROR'
export const RESET_GET_ALL_LICENSES = 'RESET_GET_ALL_LICENSES'

export interface GetAllLicenses {
  type: typeof GET_ALL_LICENSES
  payload: GetAllLicensesOutDto
}

export interface GetAllLicensesSuccess {
  type: typeof GET_ALL_LICENSES_SUCCESS
  payload: GetAllLicensesInDto
}

export interface GetAllLicensesError {
  type: typeof GET_ALL_LICENSES_ERROR
  payload: string | boolean
}

export interface ResetGetAllLicenses {
  type: typeof RESET_GET_ALL_LICENSES
  payload: null
}

export interface State {
  data: GetAllLicensesInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions =
  | GetAllLicenses
  | GetAllLicensesSuccess
  | GetAllLicensesError
  | ResetGetAllLicenses
